import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { customerQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
import { StackBlock, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { usePaymentState } from '../../../context/CheckoutPaymentContext';
export const PersonalDetailsSummary = () => {
    var _a;
    const { t } = useTranslation([I18N_NAMESPACES.buy]);
    const { defaultRequestParams, servicesEndpoint, lang } = useAemConfig();
    const [state] = usePaymentState();
    const { getTitles } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { data: customerTitles } = useQuery(getTitles({ lang }, {
        enabled: !!state,
    }));
    if (!state) {
        return null;
    }
    const { info: { customerDetails, requiresDelivery }, } = state;
    if (!customerDetails) {
        return null;
    }
    const title = (_a = customerTitles === null || customerTitles === void 0 ? void 0 : customerTitles.options.find(customerTitle => customerTitle.value === customerDetails.idTitle)) === null || _a === void 0 ? void 0 : _a.label;
    return (_jsxs(StackBlock, { gap: "1", children: [_jsx(TextAlpha, { variant: "subheadingS", children: t('buy.personal.data.summary.title') }), _jsxs(TextAlpha, { children: [title ? `${title} ` : '', customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.firstName, " ", (customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.middleName) ? `${customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.middleName} ` : '', customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.lastName] }), !requiresDelivery && (_jsx(TextAlpha, { color: "success", testId: "delivery_promise", children: t('buy.payment.delivery.information.evoucher') }))] }));
};
